/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whats_New_EmptyInputs */

const en_whats_new_empty = /** @type {(inputs: Whats_New_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No release notes in this version.`)
};

const de_whats_new_empty = /** @type {(inputs: Whats_New_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Versionshinweise in dieser Version.`)
};

/**
* | output |
* | --- |
* | "No release notes in this version." |
*
* @param {Whats_New_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const whats_new_empty = /** @type {((inputs?: Whats_New_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whats_New_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_whats_new_empty(inputs)
	return en_whats_new_empty(inputs)
});